import { useContext } from "react"

import Modal from "@/context/ModalContext"

export const useModal = () => {
  return useContext(Modal)
}

export default useModal
